export default __webpack_public_path__ + "static/media/toss.7bc81b03.webp";